import * as Yup from 'yup';

import { VALIDATION_TYPES } from '../../../../../shared/constants/global';
import { validateDateExpression } from '../expressionHelpers';
import {
  type FieldSchema,
  getFieldValidations,
  type ValidatorContext,
} from '../types';

const createDateValidator = (context: ValidatorContext): FieldSchema => {
  const { field, l, isRequired, requiredMessage, currentValues, entityData } =
    context;
  const validations = getFieldValidations(field);

  let validator = Yup.date().nullable();

  validations.forEach((rule) => {
    if (
      rule.type === VALIDATION_TYPES.EXPRESSION &&
      rule.value &&
      typeof rule.value === 'string'
    ) {
      const ruleValue = rule.value;

      validator = validator.test(
        'expression-validation',
        rule.message || l('Validation failed'),
        (value) =>
          validateDateExpression(
            value,
            ruleValue,
            field.fieldName,
            currentValues ?? {},
            entityData ?? null
          )
      );
    }
  });

  if (isRequired && 'isReadOnly' in field && !field.isReadOnly) {
    validator = validator.required(
      requiredMessage ?? l('This field is required')
    );
  }

  return validator;
};

export default createDateValidator;
